/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsHoldersConfig } from '../../config/settings.config';
export interface ISettingsHoldersPluginMethods extends IPluginMethodMap {
  getSettingsHoldersSync(args?: any): any;
}

export class SettingsHoldersPlugin implements IAgentPlugin {
  readonly methods: ISettingsHoldersPluginMethods;

  constructor() {
    this.methods = {
      getSettingsHoldersSync: this.getSettingsHoldersSync.bind(this),
    };
  }

  getSettingsHoldersSync(args?: any) {
    return {
      settings: settingsHoldersConfig,
    };
  }
}
